// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cace5d88","977":"0e98a8a0"}[chunkId] + ".chunk.js";
};